import { GetCustomEventsResponseBodyType } from "@intelligems/ig-types/functions/custom-events/get-custom-events";
import { customEventsKeys } from "@src/api/queryKeys";
import { queryOptions, useQuery } from "@tanstack/react-query";

import { api } from "../api";

const getAllCustomEvents = async () => {
  const resp =
    await api.get<GetCustomEventsResponseBodyType>("/v2/custom-events");
  return resp.data;
};

// Shared query definition -- lets non-component code (e.g. redux listener
// middleware, which can't call hooks) go through `queryClient.fetchQuery` /
// `prefetchQuery` with the exact same key + fetcher `useGetAllCustomEvents`
// uses, instead of exporting the raw fetcher for direct use.
export const customEventsQueryOptions =
  queryOptions<GetCustomEventsResponseBodyType>({
    queryKey: customEventsKeys.all,
    queryFn: getAllCustomEvents,
  });

export const useGetAllCustomEvents = () => {
  return useQuery(customEventsQueryOptions);
};
